var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.6,403.7c7.4-0.2,14.5-2.9,20-7.8v6.6h13.2v-39h-30.8v13.3h17.5v0c-0.6,3.6-2.7,6.8-5.9,8.8c-3.6,2.3-7.7,3.5-12,3.3 c-5.6,0.2-10.9-2-14.8-6c-3.9-4.2-5.9-9.7-5.6-15.4c-0.2-5.6,1.8-11.1,5.6-15.3c3.6-4,8.7-6.3,14.1-6.1c6.9-1,13.5,3.2,15.3,10H281 c-0.9-7-4.6-13.3-10.1-17.5c-6-4.7-13.5-7.2-21.2-7c-9.5-0.2-18.6,3.6-25.1,10.6c-6.7,7.1-10.4,16.5-10.1,26.2 c-0.3,9.4,3.2,18.5,9.6,25.4C230.1,400.3,238.7,404,247.6,403.7L247.6,403.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295,332.5h14.8v70H295V332.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M339.6,373.5h23.2v-13.4h-23.2v-14.3h25.3v-13.3h-40.1v70h14.8V373.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M559.4,163.4v-0.8c-0.4-0.9-1-1.8-1.7-2.5L435.2,37.5c-0.7-0.7-1.6-1.3-2.5-1.7h-0.8c-0.8-0.4-1.7-0.7-2.6-0.9H183.8 c-4.8,0-8.8,3.9-8.8,8.8V280h-26.2c-4.8,0-8.8,3.9-8.8,8.8v157.5c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6H175v61.2 c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6h367.5c2.3,0,4.5-0.9,6.2-2.6s2.6-3.9,2.6-6.2v-350v-0.5 C559.9,164.9,559.7,164.1,559.4,163.4L559.4,163.4z M437.5,64.8l92.7,92.7h-92.7V64.8z M157.5,297.5H420v140H157.5V297.5z  M192.5,507.5V455h236.2c2.3,0,4.5-0.9,6.2-2.6s2.6-3.9,2.6-6.2V288.7c0-2.3-0.9-4.5-2.6-6.2s-3.9-2.6-6.2-2.6H192.5V52.5H420v113.8 c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6h113.8v332.5H192.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/gif.941b192896ef2c22059c0d29e2393680.svg";
export { ForwardRef as ReactComponent };